<script setup>
import { ref, onMounted, computed } from 'vue';

const radial = ref();

const props = defineProps({
    score: {
        type: Number,
        required: true,
    },
});

const totalLength = ref(0);

onMounted(() => totalLength.value = radial.value.getTotalLength());

const scoreRadialDashOffset = computed(() => Math.max(0, totalLength.value * ((100 - props.score) / 100)));
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
    >
        <g id="GaisWidgetRadialScoreContainer">
            <circle
                id="GaisWidgetTotalScoreBg"
                cx="80"
                cy="80"
                r="50"
                fill="#3f414b"
                transform="translate(20, 20)"
            />
            <text
                id="GaisWidgetTotalScoreHeadline"
                x="50%"
                y="39%"
                text-anchor="middle"
                font-family="Lato, Arial, sans-serif"
                fill="#14b15e"
                font-weight="900"
                font-size="16px"
                dy=".4em"
            >
                GAIS
            </text>
            <text
                id="GaisWidgetTotalScoreLabel"
                x="50%"
                y="50%"
                text-anchor="middle"
                font-family="Lato, Arial, sans-serif"
                fill="white"
                font-weight="900"
                font-size="28px"
                dy=".4em"
            >
                {{ score }}
            </text>
            <text
                id="GaisWidgetTotalScorePercent"
                x="50%"
                y="61%"
                text-anchor="middle"
                font-family="Lato, Arial, sans-serif"
                fill="#14b15e"
                font-weight="900"
                font-size="12px"
                dy=".4em"
            >
                /100
            </text>
        </g>

        <path
            class="bg"
            stroke="hsla(0,0%,0%, .1)"
            d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
            fill="none"
        />
        <path
            id="GaisTotalScoreRadial"
            ref="radial"
            class="radial"
            stroke="#14b15e"
            d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
            fill="none"
            stroke-dasharray="475"
            :stroke-dashoffset="scoreRadialDashOffset"
            stroke-linecap="round"
            transform="translate(0,100) scale(-1, 1) translate(-200, -100) scale(1, 1) scale(1, 1) rotate(90, 100, 100)"
        />
    </svg>
</template>
